export default __webpack_public_path__ + "static/media/litepaperv2.823c0ffc.pdf";